/* Luvra — the heated scarf landing (31.10.2026, design B «Wrapped in colour», brand/DESIGN.md).
   Own parts: the page takes the picked scarf colour (.lv[data-c]); the heat dial (3 levels, real supplier numbers); a colour PER
   scarf in a set, sent as line-item properties «Scarf 1», «Scarf 2», … (the variant = the set size only).
   Pipes (ported from the shared store engine, shop/ohneat/theme/assets/on.js — same element ids): qty lock on every page, one geo
   switch to the visitor's country, prices from the variants in the buyer's currency, USD shipping converted with
   Shopify.currency.rate (+ whole-unit rounding detected on the protection product), one bag line (another set REPLACES it), the
   «Make it 2» swap, shipping protection ON by default (the buyer's untick is kept), checkout = /cart/clear.js → /cart/add.js → /checkout.
   No popup, no fake urgency: the ticker switches to the after-sale text by the REAL end date. */
/* qty lock (owner 24.10): bundle variants only — one line per product, quantity 1 (landing and /cart: layout theme.liquid loads this file) */
(function () {
  var r = document.querySelector('.m'); if ((r && r.dataset.demo === 'true') || !window.fetch) return;
  var H = { 'Content-Type': 'application/json' }, fixed = false;
  function pass(n) {
    if (n > 8) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (c) {
      var seen = {}, fix = null;
      (c.items || []).forEach(function (it) {
        if (fix || it.handle === 'shipping-protection') return;
        if (seen[it.product_id]) fix = { id: it.key, quantity: 0 };
        else { seen[it.product_id] = 1; if (it.quantity > 1) fix = { id: it.key, quantity: 1 }; }
      });
      if (!fix) { if (fixed && location.pathname === '/cart') location.reload(); return; }
      fixed = true;
      return fetch('/cart/change.js', { method: 'POST', headers: H, body: JSON.stringify(fix) }).then(function () { pass(n + 1); });
    }).catch(function () {});
  }
  pass(0);
})();

/* ticker: after the real Black Friday end the text switches by itself (Liquid renders the right one at load too) */
(function () {
  var t = document.getElementById('lv-tick'), root = document.querySelector('.m'); if (!t || !root) return;
  var end = Date.parse(root.dataset.bfEnd || '');
  if (end && Date.now() > end && t.dataset.after) t.textContent = t.dataset.after;
})();

(function () {
  var root = document.querySelector('.m.lv'), dataEl = document.getElementById('m-data'); if (!root || !dataEl) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var D = root.dataset, demo = D.demo === 'true';
  var I = JSON.parse(dataEl.textContent), U = I.unit, C = I.colors, KEYS = ['blush', 'oat', 'slate', 'black'];
  var PROT = parseFloat(String(D.protPrice).replace(',', '.')) || 0, PROT_USD = parseFloat(D.protUsd) || 0;
  var RATE = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  var ROUNDED = RATE !== 1 && PROT_USD > 0 && Math.abs(PROT - Math.ceil(PROT_USD * RATE - 1e-9)) < 0.001 && Math.abs(PROT - Math.round(PROT_USD * RATE * 100) / 100) > 0.001;
  var SHIP_RAW = (parseFloat(D.shipPaid) || 0) * RATE;
  var SHIP = ROUNDED ? Math.ceil(SHIP_RAW - 1e-9) : Math.round(SHIP_RAW * 100) / 100, FREE_N = +D.shipFree || 2;
  var store = { get: function (k) { try { return localStorage.getItem('lv_' + k); } catch (e) { return null; } },
                set: function (k, v) { try { localStorage.setItem('lv_' + k, v); } catch (e) {} } };
  function r2(v) { return Math.round(v * 100 + 1e-6) / 100; }
  var NF = null; try { if (D.iso) NF = new Intl.NumberFormat('en', { style: 'currency', currency: D.iso }); } catch (e) {}
  function money(v) { return NF ? NF.format(r2(v)) : '$' + r2(v).toFixed(2); }
  function V(n) { return I.v[String(n)]; }
  function units(n) { return n === 1 ? '1 ' + U.one : n + ' ' + U.many; }
  function pct(it) { return it.was > it.price ? Math.round((it.was - it.price) * 100 / it.was) : 0; }
  function toast(t) { var el = $('#m-toast'); el.textContent = t; el.hidden = false; clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 3000); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // one automatic switch to the visitor's country (= local currency) by IP, only to a country the store sells to
  if (!demo && !store.get('geo')) {
    store.set('geo', '1');
    fetch('/browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true').then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c || c === D.country || !$('#m-country') || !$('#m-country option[value="' + c + '"]')) return;
        var f = document.createElement('form'); f.method = 'post'; f.action = '/localization'; f.style.display = 'none';
        [['form_type', 'localization'], ['utf8', '✓'], ['_method', 'put'], ['country_code', c], ['return_to', location.pathname + location.search]]
          .forEach(function (kv) { var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i); });
        document.body.appendChild(f); f.submit();
      }).catch(function () {});
  }

  /* ---------- delivery estimate (business days, Mon–Fri) ---------- */
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  try { var now = new Date(); $('#m-d-deliv').textContent = fmt(addBiz(now, (+D.shipMin || 2) + (+D.delMin || 7))) + ' – ' + fmt(addBiz(now, (+D.shipMax || 4) + (+D.delMax || 14)));
  } catch (e) {}

  /* ---------- colour of the page (= the first scarf) ---------- */
  var st = { colors: [], n: 1, gi: 0 };
  function paint(k) {
    root.dataset.c = k;
    $$('.lv-dot').forEach(function (b) { var on = b.dataset.c === k; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
    $$('.lv-hero__pic img[data-for]').forEach(function (im) { im.hidden = im.dataset.for !== k; });
    $('#lv-cname').textContent = C[k].name;
    $('#lv-cothers').textContent = KEYS.filter(function (x) { return x !== k; }).map(function (x) { return C[x].name; }).join(', ').replace(/, ([^,]*)$/, ' and $1');
    var tc = document.querySelector('meta[name="theme-color"]'); if (tc) tc.content = getComputedStyle(root).getPropertyValue('--field').trim() || tc.content;
    gallery(k);
  }
  function gallery(k) {
    var g = C[k].gallery, box = $('#lv-thumbs'); if (!box) return;
    box.innerHTML = g.map(function (src, i) { return '<button type="button" class="' + (i ? '' : 'is-on') + '" data-src="' + esc(src) + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(src.replace('_1100x', '_200x')) + '" alt="" loading="lazy"></button>'; }).join('');
    setImg(g[0]);
  }
  function setImg(src) { var m = $('#m-main'); if (!m) return; if (m.getAttribute('src') !== src) { m.style.opacity = 0; setTimeout(function () { m.src = src; m.style.opacity = 1; }, 140); }
    $$('#lv-thumbs button').forEach(function (t) { t.classList.toggle('is-on', t.dataset.src === src); }); }
  $('#lv-thumbs') && $('#lv-thumbs').addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) setImg(b.dataset.src); });

  /* ---------- heat dial ---------- */
  var USE = { 1: 'For the desk, the couch, the car.', 2: 'For the walk and the commute.', 3: 'For the bus stop at 19°F.' };
  function level(l) {
    $$('.lv-lv').forEach(function (b) { var on = +b.dataset.l === l; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
    $('#lv-fill').style.width = (l - 1) * 50 + '%'; $('#lv-use').textContent = USE[l];
  }
  $$('.lv-lv').forEach(function (b) { b.addEventListener('click', function () { level(+b.dataset.l); }); });
  level(3);

  $$('[data-prot-m]').forEach(function (el) { el.textContent = money(PROT); });
  $$('[data-ship-m]').forEach(function (el) { el.textContent = money(SHIP); });

  $$('.lv-dot').forEach(function (b) { b.addEventListener('click', function () { st.colors[0] = b.dataset.c; paint(b.dataset.c); renderColors(); }); });
  if (demo) { paint('blush'); return; }   // no product: static showcase, «Add to bag» disabled in Liquid

  /* ---------- buy box ---------- */
  var sizes = Object.keys(I.v).map(Number).sort(function (a, b) { return a - b; });
  st.n = V(+D.defaultSet) ? +D.defaultSet : sizes[0];
  st.colors = ['blush', 'slate', 'oat'];
  $$('.m-tier').forEach(function (b) { b.hidden = !V(+b.dataset.n); });
  function renderColors() {
    var box = $('#lv-colors'); if (!box) return; var h = '';
    for (var i = 0; i < st.n; i++) {
      var cur = st.colors[i] || 'blush';
      h += '<div class="lv-crow" data-i="' + i + '"><span>' + (st.n > 1 ? 'Scarf ' + (i + 1) : 'Colour') + '<small>' + C[cur].name + '</small></span><div>' +
        KEYS.map(function (k) { return '<button type="button" class="lv-dot--' + k + (k === cur ? ' is-on' : '') + '" data-k="' + k + '" aria-label="' + C[k].name + (st.n > 1 ? ' for scarf ' + (i + 1) : '') + '" aria-pressed="' + (k === cur) + '"></button>'; }).join('') + '</div></div>';
    }
    box.innerHTML = h;
  }
  $('#lv-colors').addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b) return; var i = +b.closest('.lv-crow').dataset.i;
    st.colors[i] = b.dataset.k; if (i === 0) paint(b.dataset.k); renderColors();
  });
  function renderBuy() {
    var it = V(st.n);
    $$('.m-tier').forEach(function (b) { var n = +b.dataset.n, x = V(n), on = n === st.n; if (!x) return;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
      $('[data-tp]', b).textContent = money(x.price); $('[data-tw]', b).textContent = x.was > x.price ? money(x.was) : '';
      $('[data-pp]', b).textContent = n === 1 ? '+ ' + money(SHIP) + ' shipping' : money(x.price / n) + ' each, free shipping'; });
    $('#m-price').textContent = money(it.price); $('#m-was').textContent = it.was > it.price ? money(it.was) : '';
    $('#m-unit').textContent = (st.n >= FREE_N ? 'Free tracked shipping' : '+ ' + money(SHIP) + ' shipping · free on ' + FREE_N) + (pct(it) ? ' · ' + pct(it) + '% off' : '');
    $('#m-buy').textContent = 'Add to bag — ' + money(it.price);
    $('#m-sticky-name').textContent = 'Heated scarf · ' + units(st.n);
    $('#m-sticky-price').textContent = money(it.price);
    var h = V(1) || V(sizes[0]); $('#m-hero-price').textContent = money(h.price);
    var two = V(2); if (two && $('#lv-two-price')) $('#lv-two-price').textContent = money(two.price);
    renderColors();
  }
  $$('.m-tier').forEach(function (b) { b.addEventListener('click', function () { st.n = +b.dataset.n; renderBuy(); }); });
  $('#lv-two-btn') && $('#lv-two-btn').addEventListener('click', function () {
    if (!V(2)) return; st.n = 2; if (st.colors[1] === st.colors[0]) st.colors[1] = st.colors[0] === 'slate' ? 'blush' : 'slate';
    renderBuy(); $('#buy').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  /* ---------- bag ---------- */
  var cart = { line: null, prot: D.protDefault === 'true' };
  try { var sv = JSON.parse(store.get('cart') || 'null');
    if (sv && sv.line && V(sv.line.n)) cart.line = { n: +sv.line.n, colors: (sv.line.colors || []).filter(function (k) { return C[k]; }) };
    if (sv && sv.protSet) { cart.prot = !!sv.prot; cart.protSet = true; } } catch (e) {}
  function save() { store.set('cart', JSON.stringify(cart)); }
  function lineColors(l) { var out = []; for (var i = 0; i < l.n; i++) out.push(l.colors[i] || l.colors[0] || 'blush'); return out; }
  var drawer = $('#m-drawer'), overlay = $('#m-overlay');
  function openCart() { renderCart(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); overlay.hidden = false; document.body.style.overflow = 'hidden'; stickyUpd(); }
  function closeCart() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); overlay.hidden = true; document.body.style.overflow = ''; stickyUpd(); }
  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', openCart); });
  $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  function buy() {
    var had = cart.line, cols = st.colors.slice(0, st.n), same = had && had.n === st.n && lineColors(had).join() === lineColors({ n: st.n, colors: cols }).join();
    cart.line = { n: st.n, colors: cols }; save(); openCart();
    if (same) toast('Already in your bag'); else if (had) toast('Switched to ' + units(st.n));
  }
  $('#m-buy').addEventListener('click', buy);
  $('#m-sticky-add').addEventListener('click', buy);
  function canUp() { return cart.line && cart.line.n === 1 && V(2); }
  $('#m-up-btn').addEventListener('click', function () {
    if (!canUp()) return; var c0 = cart.line.colors[0] || 'blush';
    cart.line = { n: 2, colors: [c0, c0 === 'slate' ? 'blush' : 'slate'] }; save(); renderCart(); toast('Upgraded to ' + units(2) + ' — change colours on the page');
  });
  $('#m-prot').addEventListener('change', function (e) { cart.prot = e.target.checked; cart.protSet = true; save(); renderCart(); });
  $('#m-lines').addEventListener('click', function (e) { if (e.target.closest('[data-rm]')) { cart.line = null; save(); renderCart(); } });
  function upText() { return (I.up_text || 'Add a 2nd ' + U.one + ' for just {incr} — FREE shipping').replace('{incr}', money(V(2).price - V(1).price)); }
  function renderCart() {
    var l = cart.line, it = l && V(l.n), empty = !it;
    if (!empty) {
      var cols = lineColors(l);
      $('#m-lines').innerHTML = '<div class="m-line" data-line="' + l.n + '"><img src="' + esc(C[cols[0]].thumb) + '" alt=""><div><b>' + esc(I.product) +
        '</b><small>' + esc(units(l.n)) + '</small><small>' + esc(cols.map(function (k) { return C[k].name; }).join(' + ')) + '</small></div><div class="m-line__p">' +
        (it.was > it.price ? '<s>' + money(it.was) + '</s>' : '') + '<b>' + money(it.price) + '</b><button type="button" class="m-line__rm" data-rm="0">Remove</button></div></div>';
    } else $('#m-lines').innerHTML = '';
    $('#m-empty').hidden = !empty; $('#m-checkout').disabled = empty;
    var up = !empty && canUp(); $('#m-up').hidden = !up;
    if (up) { $('#m-up-price').textContent = '+' + money(V(2).price - it.price); $('#m-up-sub').textContent = 'A second scarf, both shipped free'; }
    var free = !empty && l.n >= FREE_N, ship = empty || free ? 0 : SHIP;
    $('#m-ship-note').textContent = empty ? '✓ FREE tracked shipping on ' + FREE_N + ' ' + U.many : free ? '✓ FREE tracked shipping' : upText();
    $('#m-ship-note').parentNode.classList.toggle('is-paid', !empty && !free);
    $('#m-sum-ship').textContent = ship ? money(ship) : 'Free'; $('#m-sum-ship').classList.toggle('m-free', !ship);
    $('#m-prot').checked = cart.prot;
    var goods = empty ? 0 : it.price, full = empty ? 0 : Math.max(it.was, it.price), prot = cart.prot && !empty ? PROT : 0;
    $('#m-sum-goods').textContent = money(goods); $('#m-sum-was').textContent = full > goods + 0.001 ? money(full) : '';
    $('#m-sum-prot-row').hidden = !prot; $('#m-sum-prot').textContent = money(prot);
    $('#m-sum-total').textContent = money(goods + prot + ship);
    $('#m-saved').textContent = full - goods > 0.004 ? 'You save ' + money(full - goods) : '';
    $('#m-count').textContent = empty ? 0 : 1;
  }
  // exactly what Checkout sends (also read by the preview checks)
  function items() {
    var l = cart.line, it = l && V(l.n); if (!it) return [];
    var props = {}; lineColors(l).forEach(function (k, i) { props[l.n > 1 ? 'Scarf ' + (i + 1) : 'Colour'] = C[k].name; });
    var out = [{ id: +it.vid, quantity: 1, properties: props }];   // always 1 (owner 24.10)
    if (cart.prot && I.prot.vid) out.push({ id: +I.prot.vid, quantity: 1 });
    return out;
  }
  window.onCartItems = items;
  $('#m-checkout').addEventListener('click', function () {
    var its = items(); if (!its.length) return;
    var btn = $('#m-checkout'); btn.disabled = true;
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: its }) }); })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); location.href = '/checkout'; })
      .catch(function () { btn.disabled = false; toast('Something went wrong — please try again.'); });
  });

  /* ---------- sticky add (mobile) ---------- */
  var buyBtn = $('#m-buy'), sticky = $('#m-sticky'), hero = $('.lv-hero');
  function stickyUpd() { if (!buyBtn || !sticky) return; var b = buyBtn.getBoundingClientRect();
    sticky.hidden = (hero && hero.getBoundingClientRect().bottom > 0) || (b.top < innerHeight && b.bottom > 0) || drawer.classList.contains('is-open'); }
  window.addEventListener('scroll', stickyUpd, { passive: true });

  paint(st.colors[0]); renderBuy(); renderCart(); stickyUpd();
})();
